import { SVGProps, Ref, forwardRef } from 'react';

export const BubbleDotRoundFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1c1.505 0 3.01.126 4.42.41-.16.543-.22 1.09-.22 1.59 0 1.017.25 2.228 1.073 3.215C18.144 7.26 19.443 7.8 21 7.8c1.059 0 1.997-.25 2.764-.738C23.917 7.656 24 8.3 24 9c0 6.052-8.922 10.602-13 14v-6.019C5.351 16.765 0 14.666 0 9c0-6 6-8 12-8M7 9.9h10V8.1H7z"
                fill="currentColor"
            />
            <path d="M21 0c2.25 0 3 1.5 3 3s-.75 3-3 3-3-1.5-3-3 .75-3 3-3" fill="currentColor" />
        </g>
    </svg>
));
BubbleDotRoundFilledSize24Glyph.displayName = 'BubbleDotRoundFilledSize24Glyph';
